import gql from 'graphql-tag';

export const SHORT_CATEGORIES = gql`
	query getCategories {
		categories {
			_id
			name
			smallImage
			largeImage
			isFeatured
		}
	}`;

export const CATEGORIES = gql`
	query getCategories {
		categories {
			_id
			name
			description
			parent
			articleCount
			version
			isFeatured
    		smallImage
    		largeImage
		}
	}`;

export const ROOT_CATEGORIES = gql`
	query rootCategories {
		rootCategories {
			_id
			name
			description
			parent
			version
			isFeatured
    		smallImage
    		largeImage
		}
	}
`;

export const FIND_CATEGORY_BY_ID = gql`
query findCategoryById($id: ID!) {
	findCategoryById(id: $id) {
		_id
		name
		description
		articleCount
		subscribersCount
		contributorsCount
	}
}
`;

export const ADD_CATEGORY = gql`
mutation addCategory($item: CategoryInputAdd) {
	addCategory(item: $item) {
			_id
			name
			description
			parent
			isFeatured
    		smallImage
    		largeImage
      		version
			promotionalContentId
			isLocked
			isPremium
	}
}
`;

export const EDIT_CATEGORY = gql`
mutation editCategory($item: CategoryInputEdit) {
	editCategory(item: $item) {
			_id
			name
			description
			parent
			isFeatured
    		smallImage
    		largeImage
			promotionalContentId
			isLocked
			isPremium
	}
}
`;

export const DELETE_CATEGORY = gql`
mutation deleteCategory($id: ID!){
	deleteCategory(id: $id) {
			_id
	}
}
`;

export const categoryFieldsFragment = gql`
	fragment CategoryNodeFields on CategoryNode {
		_id
		name
		description
		articleCount
		version
		parent
		views
  		level
		isFeatured
    	smallImage
    	largeImage
		promotionalContentId
		promotionalContent {
			_id
			name
			link
			articleImage
		}
		subscribersCount
		isLocked
		isPremium
	}
`;

export const categoryFullFieldsFragment = gql`
	fragment CategoryNodeFields on CategoryNode {
		_id
		name
		description
		articleCount
		version
		parent
		views
  		level
		isFeatured
    	smallImage
    	largeImage
		promotionalContentId
		promotionalContent {
			_id
			name
			link
			articleImage
		}
		subscribersCount
	}
`;

export const categoriesAsTreePartial = `
categoriesAsTree {
	...CategoryNodeFields
	children {
		...CategoryNodeFields
		children {
			...CategoryNodeFields
			children {
				...CategoryNodeFields
				children {
					...CategoryNodeFields
				}
			}
		}
	}
}`



export const CATEGORIES_TREE = gql`query categoriesAsTree {
	${categoriesAsTreePartial}
}
${categoryFieldsFragment}
`;

export const CATEGORIES_TREE_INTEREST = gql`query categoriesAsTree {
	${categoriesAsTreePartial}
	getAllInterests
}
${categoryFieldsFragment}

`;

export const CATEGORIES_LIST_TREE = gql`query categoriesAsTree {
	${categoriesAsTreePartial}
}
${categoryFullFieldsFragment}
`;


export const GET_PROMOTIONS_SHORT = gql`
query promotionalContent {
	promotionalContent{
	  _id
	  name
	}
  }
  `;

